<template>
    <div>
        <NotificationDialog ref="notificationDialog"/>

        <a href="" class="sidebar-toggle" role="button" tooltip="Скрыть/показать меню" @click.prevent="appSidebarToggle()">
            <i class="fa fa-bars"></i>
            <span class="sr-only" tooltip="Скрыть/показать меню">☰</span>
        </a>

        <div class="navbar-custom-menu pull-left">
            <ul class="nav navbar-nav">
                <li>
                    <header href="#" v-html="title"/>
                </li>
            </ul>
        </div>

        <div class="navbar-custom-menu">
            <ul class="nav navbar-nav" :class="{admRedMR: hasAdminReturn}">
                <li class="user-menu" v-if="currentUser.role === 'clinics'">
                    <a v-tooltip="{content: 'Помощь'}" href="/manuals/clinicsFaq" class="dropdown-toggle" onclick="window.open('/manuals/clinicsFaq'); return false;">
                        <i class="fa fa-question"></i>
                    </a>
                </li>

                <li class="user-menu" v-if="['clinics', 'network'].indexOf(currentUser.role) !== -1">
                    <a v-tooltip="{content: 'Контакты'}" href="#" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-phone"></i>
                    </a>
                    <ul class="dropdown-menu">
                        <li class="user-body" style="width: 200px">
                            <h5 style="margin-top: 0">Позвоните нам:</h5>
                            <div style="margin-top: 0;">
                                <div><a href="tel:+74996491249"><b>(499)&nbsp;649‑12‑49</b> Москва</a></div>
                                <div><a href="tel:+78124244824"><b>(812)&nbsp;424‑48‑24</b> СПб</a></div>
                                <div><a href="tel:+78005000463"><b>(800)&nbsp;500-04-63</b> Россия</a></div>
                            </div>

                            <h5>Напишите нам:</h5>
                            <div style="margin-top: 0">
                                <a href="mailto:client@doctu.ru"><b>client@doctu.ru</b></a>
                            </div>

                            <h5>Предложите нам идею:</h5>
                            <div style="margin-top: 0">
                                <a href="mailto:info@doctu.ru" target="_blank"><b>info@doctu.ru</b></a>
                            </div>
                        </li>
                    </ul>
                </li>

                <li class="user-menu">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="far fa-bell"/>
                        <small v-if="notifications.unreadCount"
                               class="label pull-right bg-red"
                               style="border-radius: 6px; top: 12px; right: 9px;">
                            {{ notifications.unreadCount }}
                        </small>
                    </a>
                    <ul v-if="notifications.totalCount"
                        class="dropdown-menu dropdown-menu-left"
                        style="right: 200px; width: 500px;"
                    >
                        <li v-for="(notification, index) in notifications.data" style="padding: 5px 10px;">
                            <div class="menuNotification"
                                 :class="{unread: !notification.read_at}"
                                 @click.stop.prevent="e => openNotification(notification, index)"
                            >
                                <div class="menuNotificationTitle">
                                    {{ notification.title }}
                                </div>
                                <div class="menuNotificationDate">
                                    {{ notification.created_at | formatDateTime }}
                                </div>
                            </div>
                        </li>
                        <li v-if="notifications.totalCount > 5" style="padding: 10px;">
                            <a :href="'/' + currentUser.role + '/notifications'" id="showAllNotifications">
                                Показать все
                            </a>
                        </li>
                    </ul>
                    <ul v-else class="dropdown-menu dropdown-menu-left" style="right: 200px; width: 500px;">
                        <li style="padding: 10px; text-align: center; font-size: 16px;">
                            <span>У вас пока нет ни одного уведомления</span>
                        </li>
                    </ul>
                </li>

                <li class="user-menu" v-if="showTariff">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-usd"></i>
                        &nbsp;Мой тариф
                    </a>
                    <ul class="dropdown-menu">
                        <li class="user-body" style="width:200px">
                            <h5 style="margin-top: 0">Название</h5>
                            <div style="margin-top: 0">
                                <b>{{ tariff.text }}</b>
                            </div>

                            <template v-if="tariff.period">
                                <h5>Срок действия</h5>
                                <div style="margin-top: 0">
                                    <b>{{ tariff.period }}</b>
                                </div>
                            </template>
                        </li>
                    </ul>
                </li>

                <li class="user-menu">
                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-user-circle"></i>
                        &nbsp;Мой профиль
                    </a>
                    <ul class="dropdown-menu">
                        <li class="user-body" style="width:200px">
                            <h5 style="margin-top: 0">ФИО</h5>
                            <div style="margin-top: 0">
                                <b>{{ currentUser.fio }}</b>
                            </div>

                            <h5>Логин</h5>
                            <div style="margin-top: 0">
                                <b>{{ currentUser.login }}</b>
                            </div>

                            <h5>Почта</h5>
                            <div style="margin-top: 0">
                                <b v-if="currentUser.email === ''"> &mdash;&nbsp;Нет&nbsp;данных&nbsp;&mdash;</b>
                                <a v-else :href="'mailto:'+ currentUser.email"><b>{{ currentUser.email }}</b></a>
                            </div>
                        </li>
                    </ul>
                </li>

                <li class="messages-menu exit" v-if="!hasAdminReturn">
                    <a v-tooltip="{content: 'Выход'}" :href="'/'+currentUser.role+'/logout'" target="_top" hint="Выход" class="hint-bottom-left">
                        <i class="fa fa-power-off"></i>
                    </a>
                </li>
            </ul>
            <button v-if="hasAdminReturn" @click="adminReturnByJWT()" class="red" style="position: absolute; right: 0; top: 0; height: 50px; padding: 10px;">
                Личный кабинет администратора
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import NotificationDialog from "@dialogs/common/Notification";

    export default {
        components: {
            NotificationDialog
        },
        props: {
            title: {
                required: true,
                type: String
            },
            tariff: {
                required: false,
                type: Object
            },
            notificationsData: {
                required: true,
                type: Object,
            }
        },
        data: function() {
            return {
                notifications: this.notificationsData,
            }
        },
        computed: {
            ...mapState({
                currentUser: state => state.currentUser,
            }),
            hasAdminReturn () {
                return this.$root.hasCookie( this.currentUser.role + '_r_to_a')
            },
            showTariff () {
                return (this.currentUser.role === 'clinics' || this.currentUser.role === 'network')
                    && (this.tariff.text !== undefined);
            }
        },
        methods: {
            adminReturnByJWT: function () {
                let scope = this;
                window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
                scope.axios.post('/' + this.currentUser.role + '/adminReturnByJWT', {}).then(function (response) {
                    if (response.data.status === "OK") {
                        window.location.pathname = response.data.pathname;
                    } else {
                        window.location.pathname = '';
                    }
                });
            },
            appSidebarToggle(e) {
                document.querySelector("body").classList.toggle('sidebar-toggle');
                for (var i = 0; i < 10; i++) {
                    setTimeout(function () {
                        $(window).trigger('resize');
                    }, i * 100);
                }
                this.$bus.fire('sidebar-toggle');
                return false;
            },
            openNotification(notification, index) {
                this.$refs.notificationDialog.show(notification);
                this.axios.post('notifications/markAsRead/' + notification.id)
                    .then(() => {
                        if (!notification.read_at) {
                            this.notifications.data[index].read_at = this.$moment().format('YYYY-MM-DD HH:mm:ss');
                            this.notifications.unreadCount--;
                            this.$bus.fire('markOpenNotification', notification)
                        }
                        this.$bus.fire('updateMenu');
                    });
            },
            markOpenNotification(notification) {
                const index = this.notifications.data.findIndex(item => item.id === notification.id);
                this.notifications.data[index].read_at = this.$moment().format('YYYY-MM-DD HH:mm:ss');
            },

        },
        created() {
            this.$bus.listen('updatedBadges', (data) => {
                if (typeof data['/notifications']!== 'undefined'){
                    this.notifications.unreadCount = data['/notifications']['count']
                }
            })
            this.$bus.listen('markOpenNotification', (notification) => {
                this.markOpenNotification(notification)
            })
        },
    }

</script>

<style>
.admRedMR {
    margin-right: 250px !important;
}

a#showAllNotifications {
    color: #3c8dbc !important;
    text-decoration: none;
    border-bottom: 1px dotted;
    width: max-content;
    padding: 0;
    margin: auto;

    &:hover {
        background-color: rgba(0, 0, 0, 0);
        color: #72afd2 !important;
    }
}

.menuNotification {
    border-radius: 3px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    padding: 10px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: #f8f9fa;
    }

    &.unread {
        border-left: 3px solid #00a65a;
        font-weight: 700;
    }

    .menuNotificationTitle {
        font-size: 16px;
        margin-bottom: 5px;
    }

    .menuNotificationDate {
        font-size: 13px;
        color: #666;
    }
}
</style>
